export const BAIDU = "http://cang.baidu.com/do/add?iu=@u&it=@t";
export const BUFFER = "https://bufferapp.com/add?text=@t&url=@u";
export const EMAIL = "mailto:?subject=@t&body=@u%0D%0A@d";
export const EVERNOTE = "https://www.evernote.com/clip.action?url=@u&title=@t";
export const BLUESKY = "https://bsky.app/intent/compose?text=@t%0D%0A@u%0D%0A@d";
export const FACEBOOK = "https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h";
export const FLIPBOARD = "https://share.flipboard.com/bookmarklet/popout?v=2&url=@u&title=@t";
export const HACKERNEWS = "https://news.ycombinator.com/submitlink?u=@u&t=@t";
export const INSTAPAPER = "http://www.instapaper.com/edit?url=@u&title=@t&description=@d";
export const LINE = "http://line.me/R/msg/text/?@t%0D%0A@u%0D%0A@d";
export const LINKEDIN = "https://www.linkedin.com/sharing/share-offsite/?url=@u";
export const MESSANGER = "fb-messenger://share/?link=@u";
export const ODNOKLASSNIKI = "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=@u&st.comments=@t";
export const PINTEREST = "https://pinterest.com/pin/create/button/?url=@u&media=@m&description=@t";
export const POCKET = "https://getpocket.com/save?url=@u&title=@t";
export const QUORA = "https://www.quora.com/share?url=@u&title=@t";
export const REDDIT = "https://www.reddit.com/submit?url=@u&title=@t";
export const SKYPE = "https://web.skype.com/share?url=@t%0D%0A@u%0D%0A@d";
export const SMS = "sms:?body=@t%0D%0A@u%0D%0A@d";
export const STUMBLEUPON = "https://www.stumbleupon.com/submit?url=@u&title=@t";
export const TELEGRAM = "https://t.me/share/url?url=@u&text=@t%0D%0A@d";
export const TUMBLR = "https://www.tumblr.com/share/link?url=@u&name=@t&description=@d";
export const TWITTER = "https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu";
export const X = "https://www.x.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu";
export const VIBER = "viber://forward?text=@t%0D%0A@u%0D%0A@d";
export const VK = "https://vk.com/share.php?url=@u&title=@t&description=@d&image=@m&noparse=true";
export const WEIBO = "http://service.weibo.com/share/share.php?url=@u&title=@t&pic=@m";
export const WHATSAPP = "https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d";
export const WORDPRESS = "https://wordpress.com/press-this.php?u=@u&t=@t&s=@d&i=@m";
export const XING = "https://www.xing.com/social/share/spi?op=share&url=@u&title=@t";
export const YAMMER = "https://www.yammer.com/messages/new?login=true&status=@t%0D%0A@u%0D%0A@d";
